import { Dialog, Transition } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import Link from "next/link";
import { Fragment } from "react";
import mixpanel from "../utils/mixpanel";

export default function JoinWhatsAppModal({
  isOpen,
  onClose,
  masterclass,
  joiningLink = "https://linktr.ee/",
}: {
  isOpen: any;
  onClose: any;
  masterclass: any;
  joiningLink: string;
}) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-30" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-70" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-[#eeebe6] p-6 text-center align-middle shadow-xl transition-all border border-white/5">
                <CheckCircleIcon className="w-16 h-16 mb-3 mx-auto text-[#9A7026] border border-[#9A7026] rounded-full" />

                <Dialog.Title
                  as="h3"
                  className="text-[18.4px] font-lato font-[400] leading-6 text-[#9A7026]"
                >
                  Registration Successful
                </Dialog.Title>
                <p className="text-[16px] font-lato font-[400] mt-[13.3px]">
                  Thank you for joining.
                </p>
                <div className="mt-2">
                  <p className="text-[16px] font-lato font-[400] text-black ">
                    Join our Whatsapp community to know more about the
                    masterclass and get notified when it&apos;s live.
                  </p>
                </div>

                <div className="mt-4 text-center">
                  <Link href={joiningLink} target="_blank">
                    <button
                      type="button"
                      className="bg-[#0A2133] text-[14px] font-[600] font-lato px-[24px] py-[11px] !text-white relative"
                      onClick={() => {
                        mixpanel.track("community_join", {
                          page_name: masterclass?.title,
                        });
                        onClose;
                      }}
                    >
                       <div className="absolute inset-0 bg-[linear-gradient(110deg,#00000000,45%,#ffffff80,55%,#00000000)] bg-[length:200%_100%] animate-shimmer rounded-md " />
                      <span>Join Whatsapp Community</span>
                    </button>
                  </Link>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
